import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  show() {
    if (this.hasOverlayTarget) this.overlayTarget.hidden = false
    this.element.querySelectorAll('[type="submit"]').forEach((el) => { el.disabled = true })
  }
}
